import React, { useEffect, useRef, useState, useContext } from "react";
import PanoramaContext from "./Context";

import { ReactComponent as CloseSvg } from "../../../assets/auth/login-close.svg";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, Pagination } from "swiper/modules";

import { ReactComponent as ArrowLeftCircleSvg } from "../../../assets/newProject/arrow-left-circle-white.svg";
import { ReactComponent as ArrowRightCircleSvg } from "../../../assets/newProject/arrow-right-circle-white.svg";

const assetsUri = import.meta.env.ASSETS_URI;

const MaterialSwitcher = () => {
  const {
    panoramas: availablePanoramas,
    selectedPanorama,
    materials,
    setSelectedPanorama,
    closeOverlay,
  } = useContext(PanoramaContext);
  const [init, setInit] = useState(undefined);

  const handleMaterialClick = (panoramaId) => {
    setSelectedPanorama(panoramaId);
    closeOverlay();
  };

  const handleCloseClick = () => {
    closeOverlay();
  };

  const { panoramas } = materials.find((m) =>
    m.panoramas.find((p) => p.panorama === selectedPanorama)
  );

  const _availablePanoramas = panoramas.filter(
    (p) => p.panorama !== selectedPanorama
  );

  let _contentWidth = 300;

  if (_availablePanoramas.length >= 3) {
    _contentWidth = "100%";
  }

  if (_availablePanoramas.length == 2) {
    _contentWidth = 624;
  }

  return (
    <div className="pannellum-materials-switcher">
      <div className="pannellum-materials-switcher-content">
        <div className="pannellum-materials-switcher-header">
          <span className="pannellum-materials-switcher-header__title">
            Select Material
          </span>
          <CloseSvg
            className="pannellum-materials-switcher-header__close"
            height={15}
            onClick={handleCloseClick}
          />
        </div>
        <div
          style={{
            width: _contentWidth,
            display: "flex",
            alignItems: "center",
            gap: 8,
          }}
        >
          <ArrowLeftCircleSvg
            className="pannellum-materials-switcher-content-types__arrow--left"
            width={48}
            style={{ cursor: "pointer", marginTop: -60 }}
          />
          <Swiper
            className="pannellum-materials-switcher-content-types"
            modules={[Autoplay, Navigation, Pagination]}
            // centeredSlides={true}
            spaceBetween={24}
            slidesPerView={1}
            autoplay={{
              delay: 5000,
              pauseOnMouseEnter: true,
            }}
            navigation={{
              enabled: true,
              prevEl:
                ".pannellum-materials-switcher-content-types__arrow--left",
              nextEl:
                ".pannellum-materials-switcher-content-types__arrow--right",
            }}
            speed={600}
            onInit={() => setInit(true)}
            loop={true}
            pagination={{
              clickable: true,
            }}
            breakpoints={{
              320: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView:
                  _availablePanoramas.length >= 2
                    ? 2
                    : _availablePanoramas.length,
              },
              1200: {
                slidesPerView:
                  _availablePanoramas.length >= 3
                    ? 3
                    : _availablePanoramas.length,
              },
            }}
          >
            {_availablePanoramas.map((p) => {
              const _matchingPanorama = availablePanoramas.find(
                (ap) => ap._id === p.panorama
              );

              return (
                <SwiperSlide
                  key={p._id}
                  className="pannellum-materials-switcher-content-types-item"
                  onClick={() => handleMaterialClick(p.panorama)}
                >
                  <img
                    className="pannellum-materials-switcher-content-types-item__image"
                    src={`${assetsUri}/${_matchingPanorama.image}`}
                    onError={({ target }) => {
                      target.src = _matchingPanorama.image;
                    }}
                  />
                  <span className="pannellum-materials-switcher-content-types-item__name">
                    {p.type}
                  </span>
                </SwiperSlide>
              );
            })}
          </Swiper>
          <ArrowRightCircleSvg
            className="pannellum-materials-switcher-content-types__arrow--right"
            width={48}
            style={{ cursor: "pointer", marginTop: -60 }}
          />
        </div>
      </div>
    </div>
  );
};

export default MaterialSwitcher;
